import { render, staticRenderFns } from "./messageModal.vue?vue&type=template&id=5180eb55&scoped=true&"
import script from "./messageModal.vue?vue&type=script&lang=js&"
export * from "./messageModal.vue?vue&type=script&lang=js&"
import style0 from "./messageModal.vue?vue&type=style&index=0&id=5180eb55&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5180eb55",
  null
  
)

export default component.exports